import { style } from 'typestyle';
import { primaryTextColor } from 'src/common-ui/theme';
import { tabsStyle, tabStyle } from 'src/common-ui/components/Filters/Filters.styles';

const agentTabStyle = {
  ...tabStyle,
  justifyContent: 'center' as const,
  alignItems: 'center' as const,
  width: '100%'
};

const AgentPanelView = style({
  overflow: 'auto',
  position: 'relative',
  width: '100%',
  // maxWidth: '400px',
  height: '95%',
  display: 'flex',
  flexDirection: 'column',
  paddingRight: '20px',
  $nest: {
    '.tabs': tabsStyle,
    '.tab': agentTabStyle,
    '.tab-content': {
      padding: '1rem',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      overflow: 'hidden',
    },
    '.content-panel': {
      display: 'flex',
      flexDirection: 'column',
      fontSize: '0.9rem',
      color: primaryTextColor,
      flex: 1,
      minHeight: 0,
      overflow: 'hidden',
    },
  },
});

export default {
  AgentPanelView,
};
